<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="structure-nxt"><span class="gray"><img alt="" class="_idGenObjectAttribute-1" src="image/1.png"/></span></p>
<p class="Normal1 ParaOverride-2"><span class="CharOverride-4">Inspirational Quotes </span><span class="CharOverride-5">&amp;</span></p>
<p class="Normal1 ParaOverride-2"><span class="CharOverride-4">Affirmations to Live By</span></p>
<p class="Normal1 ParaOverride-2"><span class="yellow CharOverride-6">June Cotner</span></p>
<p class="Normal1 ParaOverride-2"><span class="CharOverride-7"><img alt="" class="_idGenObjectAttribute-2" src="image/MangoPublishingLogo.png"/></span></p>
<p class="Normal1 ParaOverride-2"><span class="CharOverride-8">Coral Gables</span></p>
<p class="body-paragraph-GRAY ParaOverride-1"> </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 97816425039441.vue?18a5a913